import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { ELAPSED_STYLES } from '../../constants';
import type { ElapsedStatus } from '../../types';

interface ElapsedPillProps {
  status: ElapsedStatus;
  text: string | null;
  tooltipText?: string | null;
}

const PillWrapper = styled.div<{ $status: ElapsedStatus }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 10px;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.03);
  background: ${props => (props.$status ? ELAPSED_STYLES[props.$status]?.bg : '#f3f4f6')};
  border: 1px solid ${props => (props.$status ? ELAPSED_STYLES[props.$status]?.border : '#e5e7eb')};
  color: ${props => (props.$status ? ELAPSED_STYLES[props.$status]?.color : '#4b5563')};
`;

const PillText = styled.span`
  display: inline-block;
`;

const PlaceholderText = styled.span`
  color: #444;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.02em;
`;

/**
 * 경과 시간 표시 Pill 컴포넌트
 * 상태에 따라 색상이 변경됨 (초록/주황/빨강)
 */
export default function ElapsedPill({ status, text, tooltipText }: ElapsedPillProps) {
  if (!status || !text) {
    return <PlaceholderText>-</PlaceholderText>;
  }

  const content = (
    <PillWrapper $status={status}>
      <PillText>{text}</PillText>
    </PillWrapper>
  );

  if (tooltipText) {
    return <Tooltip title={tooltipText}>{content}</Tooltip>;
  }

  return content;
}
